import { gql } from 'graphql-request';

export const assembledPhotosGql = gql`
assembledProductImagesTitle
assembledProductImagesCount
`;

export type AssembledPhotosData = {
  assembledProductImagesTitle: string;
  assembledProductImagesCount: number;
};
